package com.evoapps.evoshift.ui.finance

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.material3.MaterialTheme
import com.evoapps.evoshift.domain.explain.Side
import com.evoapps.evoshift.domain.model.DailyRecord
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.money_per_hour
import evoshift.composeapp.generated.resources.spmh_plan
import evoshift.composeapp.generated.resources.spmh_real
import org.jetbrains.compose.resources.stringResource

/*
 * SH-191: SPMH (sales per man-hour, the owner's own term) wherever a labour % is shown: money per
 * hour in the workplace currency ("312 zł/h"), a dash without hours or takings. Tapping the figure
 * explains it (SPMH: sales per man-hour, the net sales and the hours behind it).
 */

/** "312 zł/h"; [dash] without a figure (no hours, or no takings yet). */
@Composable
fun formatSpmhOrDash(value: Double?, currency: String, dash: String = "-"): String =
    value?.let { stringResource(Res.string.money_per_hour, formatWholeMoney(it, currency)) } ?: dash

/** A day's SPMH plan | actual as a row of [CardFigures], under its labour %. */
@Composable
internal fun DaySpmhFigures(
    record: DailyRecord,
    currency: String,
    labelColor: Color = MaterialTheme.colorScheme.onSurfaceVariant,
    highlightColor: Color = MaterialTheme.colorScheme.primary,
    highlightSecond: Boolean = false,
    preview: Boolean = false
) {
    val why = rememberDayWhy(record)
    CardFigures(
        stringResource(Res.string.spmh_plan) to formatSpmhOrDash(record.spmhPlan, currency),
        stringResource(Res.string.spmh_real) to formatSpmhOrDash(record.spmhActual, currency),
        firstWhy = why.spmh(Side.PLAN), secondWhy = why.spmh(Side.ACTUAL), currency = currency,
        highlightSecond = highlightSecond && record.spmhActual != null,
        labelColor = labelColor,
        highlightColor = highlightColor,
        preview = preview
    )
}
